// src/app/_service/startup.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { DataService } from './data.service';
import { UserSettingsService } from './user-settings.service';
import { AbandonedSessionRecoveryService } from './abandoned-session-recovery.service';

@Injectable({ providedIn: 'root' })
export class StartupService {
  constructor(
    private dataService: DataService,
    private userSettingsService: UserSettingsService,
    private router: Router,   // ✅ inject router properly
    private abandonedSessionRecovery: AbandonedSessionRecoveryService,
  ) {}

  async initialize(): Promise<void> {
    try {
      console.log('[Startup] Initializing Notes-App data...');

      // 1️⃣ Load data and sync (user settings already initialized via APP_INITIALIZER)
      await this.dataService.initialize();

      console.log('[Startup] Initialization complete.');

      // ✅ Optional: Safari-specific repaint fix (moved *after* initialization)
      this.setupSafariRepaintFix();

      // Autosave Stage 3 — look for opening snapshots left behind by edit
      // sessions that never closed normally. Never blocks startup on this;
      // any failure is caught and logged inside the service itself too.
      void this.abandonedSessionRecovery.checkForAbandonedSessions();

    } catch (err) {
      console.error('[Startup] Initialization failed', err);
    }
  }

  /** Safari sometimes caches transforms after route navigation. */
  private setupSafariRepaintFix(): void {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      requestAnimationFrame(() => {
        document.body.style.display = 'none';
        // force reflow
        document.body.offsetHeight;
        document.body.style.display = '';
      });
    });
  }
}
